import { render, staticRenderFns } from "./ProjectSendDialog.vue?vue&type=template&id=f5b5ca2a&scoped=true&"
import script from "./ProjectSendDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectSendDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSendDialog.vue?vue&type=style&index=0&id=f5b5ca2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b5ca2a",
  null
  
)

export default component.exports